interface SummaryCardShippingAmounts {
  /** Label, carrier upgrade, pickup and exchange shipping charged by card at submit. */
  shippingDueNow: number;
  showsCarrierUpgrade: boolean;
}

/**
 * Shipping the shopper pays by card at submit. The carrier upgrade is part of
 * the shopper-owed shipping fee, so it is deducted or charged with the label.
 * Stripe-billed exchange shipping is never deducted, so it stays due now.
 */
export function getSummaryCardShippingAmounts({
  labelDeducted,
  stripeShippingFee,
  stripeExchangeShippingFee,
  carrierUpgradeFeeComponent,
}: {
  labelDeducted: boolean;
  stripeShippingFee: number;
  /** Stripe-billed exchange shipping plus its landed cost; part of `stripeShippingFee`. */
  stripeExchangeShippingFee: number;
  carrierUpgradeFeeComponent: number | undefined;
}): SummaryCardShippingAmounts {
  const dueNow = labelDeducted ? stripeExchangeShippingFee : stripeShippingFee;
  return {
    shippingDueNow: dueNow > 0 ? dueNow : 0,
    showsCarrierUpgrade: (carrierUpgradeFeeComponent ?? 0) > 0,
  };
}
